import * as Lib from '../state/runs/lib';
import type * as Types from '../state/runs/types';

/**
 * This used to be called the `RunsDataQuery` but that's misleading - what this type actually represents is the configuration which may apply across _multiple_ subqueries (such as query per runset), and those subqueries are included in this type as `runsetQueries` (renamed from `queries`).
 *
 * Certain kinds of failures arise from blending the scope of these two things together. For example, grouping:
 * - if grouping is enabled via a workspace config (like an aggregation), then all subqueries will be grouped
 * - but if grouping is specifically enabled for a runset, that doesn't imply all subqueries related to this config will be grouped
 */
export type RunsDataQueryConfig = Types.QueryConfig;
export type RunsData = Types.Data;
export type RunWithRunsetInfo = Types.RunWithRunsetInfo;

export type QueryToRunsDataQueryParams = Lib.QueryToRunsDataQueryParams;
export const toRunsDataQueryConfig = Lib.toRunsDataQueryConfig;
